import { c as _c } from "react/compiler-runtime";
import type { CodeContent } from '@/types/github';
import type { LucideIcon } from 'lucide-react';
import { FileIcon, FileMinus, FilePlus } from 'lucide-react';
import { cn } from '@/lib/utils';
type FileStatusIconStyle = {
  Icon: LucideIcon;
  className?: string;
};
const MODIFIED_FILE_ICON: FileStatusIconStyle = {
  Icon: FileIcon
};

// GitHub can also report a file as copied, changed or unchanged; those read as modified.
const FILE_STATUS_ICONS: Record<CodeContent['status'], FileStatusIconStyle> = {
  added: {
    Icon: FilePlus,
    className: 'text-green-600/80'
  },
  removed: {
    Icon: FileMinus,
    className: 'text-red-600/80'
  },
  renamed: {
    Icon: FileIcon,
    className: 'text-amber-600/80'
  },
  modified: MODIFIED_FILE_ICON,
  copied: MODIFIED_FILE_ICON,
  changed: MODIFIED_FILE_ICON,
  unchanged: MODIFIED_FILE_ICON
};

/** A status's own color wins over one in `className`, so `className` can color modified files. */
export function PrV2FileStatusIcon(t0) {
  const $ = _c(6);
  const {
    status,
    className
  } = t0;
  const {
    Icon,
    className: statusClassName
  } = FILE_STATUS_ICONS[status];
  let t1;
  if ($[0] !== className || $[1] !== statusClassName) {
    t1 = cn(className, statusClassName);
    $[0] = className;
    $[1] = statusClassName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== Icon || $[4] !== t1) {
    t2 = <Icon className={t1} />;
    $[3] = Icon;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}